import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "text-4xl text-primary-700 font-bold" }, "Change Phone Number", -1)
const _hoisted_2 = { class: "bg-white rounded-lg px-5 py-9 w-full" }
const _hoisted_3 = { class: "md:w-1/2" }
const _hoisted_4 = { class: "mb-6" }

import PortalLayout from '@/layouts/PortalLayout.vue';
import PageLoader from "@/components/PageLoader.vue";
import ErrorModal from '@/components/ErrorModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';

import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import patient from "@/classes/UserData";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditAccountDetails',
  setup(__props) {

const router = useRouter();

const loader = ref(false)
const showError = ref(false)
const errorMsg = ref(null)
const errors      = ref([])
const showSuccess = ref(false)
const showConfirmation = ref(false)

const patientData = computed(() => patient.getCurrentUser())
const payload = ref({
    patient_id: patientData.value.patient_id,
    mobile_number: null,
})

const updateProfile = () => {
    loader.value = true;

    patient.updateProfile(payload.value)
        .then((result: any) => {
            loader.value = false;
            if(result.data.data[0].status == 'success') {
                showSuccess.value = true;

                setTimeout(() => {
                    window.location.replace('/account-details')
                }, 1000)
            }
        })
        .catch((error: any) => {
            loader.value = false;
            showError.value = true;
            errorMsg.value = error.response.data.message;

            if(error.response.status == 422) {
                errors.value = error.response.data.errors;
            }

            if(error.response.status == 401) {
                window.location.replace('/login');
            }
        })
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, { defaultTitle: false }, {
    title: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(TextInput, {
              add_on_left: true,
              add_on_text: "+63",
              placeholder: 'Mobile Number',
              maxlength: "10",
              oninput: "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*)\\./g, '$1');",
              modelValue: payload.value.mobile_number,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((payload.value.mobile_number) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", null, [
            _createVNode(ButtonComponent, {
              disabled: loader.value,
              text: "Save Changes",
              type: 'submit',
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = true))
            }, null, 8, ["disabled"])
          ])
        ])
      ]),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(ErrorModal, {
        width: "w-[548px]",
        title: "Error",
        "action-text": "Close",
        "cancel-text": "Go back",
        show: showError.value,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (showError.value = false)),
        onConfirm: _cache[3] || (_cache[3] = ($event: any) => (showError.value = false)),
        errors: errors.value
      }, {
        content: _withCtx(() => [
          _createTextVNode(_toDisplayString(errorMsg.value), 1)
        ]),
        _: 1
      }, 8, ["show", "errors"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Confirm",
        title: "Profile Submitted!",
        content: "Profile has been updated successfully",
        "no-btn": ""
      }, null, 8, ["show"]),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[7] || (_cache[7] = ($event: any) => {showConfirmation.value = false; updateProfile() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Submit Changes?",
        content: "Are you sure you wish to update this profile?"
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})